import { Config } from '../../config'

export const labdepotConfig: Config = {
  partner: 'labdepot',
  catalog: 'partner',
  displayName: 'The Lab Depot',
  accentColor: '#376392',
  host: 'seating.labdepotinc.com',
  extraAttributes: {
    hideProduct: 'Wood'
  }
}

